import { InferType, number, object } from "yup";

export const BoostSiloSchema = object({ numberOfTexts: number().required().default(50) });

export const UpsertNumberOfTextsSchema = object({
    numberOfTexts: number().required().default(50),
});

export type BoostSilo = InferType<typeof BoostSiloSchema>;
export type UpsertNumberOfTexts = InferType<typeof UpsertNumberOfTextsSchema>;
